import React from "react";
import { useTranslation } from "react-i18next";
import "../../i18next";
import AnimatedElement from "../AnimatedElement";
import logo from "../../assets/images/home/Logo.png";

function ContactInfo() {
  const { t } = useTranslation();

  const isMobile = window.innerWidth < 768;

  return (
    <section id="Contacts">
      <div className="max-w-6xl px-5 mx-auto text-center m-4">
        {/* Bloque de contactos animado */}
        <AnimatedElement
          fromDirection="left"
          className="flex flex-col md:flex-row justify-center items-center gap-4"
        >
          <div className="flex flex-col items-center p-10 space-y-6 rounded-lg bg-veryLightGray w-full md:w-1/3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-12 -mt-14 bg-transparent rounded-b-lg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
              />
            </svg>
            <h5 className="text-lg font-bold color-blue-dark-atm">
              {t("general_information")}
            </h5>
            <p className="text-sm color-blue-dark-atm">
              {t("home_contact_text1")}
            </p>
            <p className="text-sm color-blue-dark-atm">
              asaavedra@atmnetss.com
            </p>
          </div>

          <div className="flex flex-col items-center p-10 space-y-6 rounded-lg bg-veryLightGray w-full md:w-1/3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-12 -mt-14 bg-transparent rounded-1/2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
              />
            </svg>

            <h5 className="text-lg font-bold color-blue-dark-atm">
              {t("banner.phoneNumber")}
            </h5>
            <p className="text-sm color-blue-dark-atm whitespace-pre-line">
              {t("home_contact_text2")}
            </p>
            <p className="text-sm color-blue-dark-atm">+1 770 449 6545</p>
          </div>

          <div className="flex flex-col items-center p-10 space-y-6 rounded-lg bg-veryLightGray w-full md:w-1/3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-12 -mt-14 bg-transparent rounded-full"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
              />
            </svg>
            <h5 className="text-lg font-bold color-blue-dark-atm">
              {t("address")}
            </h5>
            <p className="text-sm color-blue-dark-atm">{t("address_atm")}</p>
            <p className="text-sm color-blue-dark-atm">{t("zipcode_atm")}</p>
          </div>
        </AnimatedElement>
      </div>
    </section>
  );
}

export default ContactInfo;
